import {Component} from 'react'
import {Redirect} from 'react-router-dom'

import Cookies from 'js-cookie'
import './index.css'

class LoginPage extends Component {
  state = {errMsg: '', username: 'rahul', password: 'rahul@2021'}

  onSubmitForm = async event => {
    event.preventDefault()
    const {username, password} = this.state
    const userDetails = {username, password}
    const url = 'https://apis.ccbp.in/login'
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(url, options)
    const data = await response.json()
    if (response.ok) {
      this.onSubmitSuccess(data.jwt_token)
    } else {
      this.onSubmitFailure(data.error_msg)
    }
  }

  onSubmitSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {
      expires: 30,
    })
    history.replace('/')
  }

  onSubmitFailure = errMsg => {
    this.setState({errMsg})
  }

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  render() {
    const {errMsg, username, password} = this.state
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <div className="login-bg-container">
        <div>
          <img
            src="https://res.cloudinary.com/sunil-bookhub/image/upload/v1686964422/Rectangle_1467book-hub-login_y5doft.png"
            alt="login"
            className="login-image"
          />
        </div>
        <div className="login-form-container">
          <form onSubmit={this.onSubmitForm} className="login-form">
            <img
              src="https://res.cloudinary.com/sunil-bookhub/image/upload/v1687139613/Group_7731bookhub-logo_kx1rkf.png"
              alt="app-logo"
              className="book-hub-logo"
            />
            <label htmlFor="username">Username*</label>
            <input
              id="username"
              type="text"
              placeholder="username"
              value={username}
              onChange={this.onChangeUsername}
            />
            <label htmlFor="password">Password*</label>
            <input
              id="password"
              type="password"
              placeholder="password"
              value={password}
              onChange={this.onChangePassword}
            />
            <p className="error-msg">{errMsg}</p>
            <button className="login-button" type="submit">
              Login
            </button>
          </form>
        </div>
      </div>
    )
  }
}
export default LoginPage
